import { GameMap, type MapFile } from '@sunderfen/shared';

export interface WorldInfo {
  id: number; name: string; location: string; capacity: number; population: number; online: boolean; wsUrl: string; map: string; tags: string[];
}

async function asJson<T>(r: Response): Promise<T> {
  const body = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error((body as { error?: string }).error ?? `Request failed (${r.status})`);
  return body as T;
}

export async function devLogin(name: string) {
  return asJson<{ token: string; name: string }>(await fetch('/api/login/dev', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ name }) }));
}
export interface ServerConfig { devLogin: boolean; providers: { id: 'google' | 'discord'; name: string }[] }
/** What this server offers. The offline build has no server: name-only login it is. */
export async function serverConfig(): Promise<ServerConfig> {
  try { return await asJson<ServerConfig>(await fetch('/api/config')); } catch { return { devLogin: true, providers: [] }; }
}
export async function signup(ticket: string, name: string) {
  return asJson<{ token: string; name: string }>(await fetch('/api/signup', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ ticket, name }) }));
}
export async function me(token: string) {
  return asJson<{ name: string; signins: string[]; providers: ServerConfig['providers'] }>(await fetch('/api/me', { headers: { authorization: `Bearer ${token}` } }));
}
export async function listWorlds() { return asJson<WorldInfo[]>(await fetch('/api/worlds')); }

const maps = new Map<string, Promise<GameMap>>();
export function loadMap(name: string) {
  let p = maps.get(name);
  if (!p) { p = fetch(`/maps/${encodeURIComponent(name)}.json`).then(r => asJson<MapFile>(r)).then(f => new GameMap(f)); maps.set(name, p); }
  return p;
}

/** Where to open the WebSocket for a world. An empty wsUrl means "this host". */
export function socketUrl(w: WorldInfo) {
  if (w.wsUrl) return w.wsUrl;
  return `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws`;
}

/* Session storage can be unavailable (private windows, embedded views); everything here is optional. */
export const session = {
  get(k: string) { try { return sessionStorage.getItem(`hm:${k}`); } catch { return null; } },
  set(k: string, v: string) { try { sessionStorage.setItem(`hm:${k}`, v); } catch { /* ignore */ } },
  del(k: string) { try { sessionStorage.removeItem(`hm:${k}`); } catch { /* ignore */ } },
};
